/** Fallback when `batchMaterialSummaryTable` is unset (matches coc-setup API default). */
export const DEFAULT_COC_SETUP_TYPE = 'ssd';
